import { Textarea as MantineTextarea, type TextareaProps as MantineTextareaProps } from '@mantine/core'

export type TextAreaProps = MantineTextareaProps

export function Textarea(props: Readonly<TextAreaProps>) {
  return <MantineTextarea {...props} />
}
